import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { appPaths, authPaths } from '~/routes/app-paths';
import { AppRoute } from '~/routes/Routes';

import { AccountCheckView } from './account-check-view/AccountCheckView';

export interface ProtectedRouteProps {
  isAuthenticated: boolean;
  config: AppRoute;
}

export const ProtectedView = ({
  isAuthenticated,
  config,
}: ProtectedRouteProps) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return config.element;
  }

  if ([authPaths.login, authPaths.signUp].includes(location.pathname)) {
    return <Navigate to={appPaths.base} replace />;
  }

  return <AccountCheckView config={config} />;
};
